export default __webpack_public_path__ + "static/project-alphabetas-thumbnail-e1e2233599bd5828362fe08ddfccc51c.png";